// extracted by mini-css-extract-plugin
export var text = "_6s-0";